import request from '@/utils/request';

// 获取转盘信息
export function getTurntableInfo(data) {
  return request({
    url: '/wap/turntable/get_turntable_info',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 抽奖
export function lottery(data) {
  return request({
    url: '/wap/turntable/lottery',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 十连抽奖
export function ten_lottery(data) {
  return request({
    url: '/wap/turntable/ten_lottery',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 会员排行榜
export function getActivityMemberTicketLists(data) {
  return request({
    url: '/wap/turntable/get_turntable_winning_record',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
